function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from '@dtsl/css-timepicker/dist/index.module.css';
const Chip = _ref => {
  let {
    value,
    isSelected,
    isDisabled,
    onClick,
    ...restProps
  } = _ref;
  const compositeChipClass = classNames({
    [styles['sib-timpicker-chip']]: true,
    [styles['sib-chip-selected']]: isSelected && !isDisabled,
    [styles['sib-chip-disabled']]: isDisabled && !isSelected
  });
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    React.createElement("div", _extends({
      className: compositeChipClass,
      key: value,
      onClick: e => onClick(value, e),
      "data-test": "chip-test-id",
      role: "button",
      tabIndex: 0
    }, restProps), value)
  );
};
Chip.defaultProps = {
  isSelected: false,
  isDisabled: false,
  onClick: () => {}
};
Chip.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  isSelected: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func
};
export default Chip;